module.exports = __webpack_public_path__ + "img/ico-leaders.c6a81a19.svg";